import './assets/App.css';
import './pages/mainpage/mainPage.css'
import './pages/about/about.css'
import { MainPage } from './pages/mainpage/MainPage'

function App() {
  
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;